import { z } from 'zod';

/**
 * Per-user read state for supplier invoices.
 *
 * The request is intentionally strict: the tenant and user are resolved from
 * the authenticated request and must never be accepted from the body.
 */
export const supplierInvoiceMarkSeenBodySchema = z.object({
  ids: z.array(z.string().uuid()).min(1).max(100),
}).strict();

export type SupplierInvoiceMarkSeenBody = z.infer<typeof supplierInvoiceMarkSeenBodySchema>;

export const supplierInvoiceUnreadCountResponseSchema = z.object({
  count: z.number().int().nonnegative(),
});

export type SupplierInvoiceUnreadCountResponse = z.infer<typeof supplierInvoiceUnreadCountResponseSchema>;

export const supplierInvoiceMarkSeenResponseSchema = z.object({
  count: z.number().int().nonnegative(),
  markedIds: z.array(z.string().uuid()),
});

export type SupplierInvoiceMarkSeenResponse = z.infer<typeof supplierInvoiceMarkSeenResponseSchema>;